define('fusion/ui/controls/fusion-pagemessage',["fusion/fusion.control"], function (ControlFactory) {
    return ControlFactory.control(function () {
        var c = this;

        c.settingsDefinition = {
        };
    });
});
